import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { AppContext } from '../context/AppContext';
import colors from '../styles/colors';
import {
  DashboardFilteresTypes,
  DashboardFiltersSubTypes,
} from '../util/CustomerFilterEnum';
import { Card, CardHeaderNumber, CardContentLine } from './MetricsCard';
import { getFilteredContacts } from '../util/customersUtil';
import useMutateAnalytics from '../util/mutate.Analytics';
import analyticsKeys from "../util/UsageStatLinks";

export default function CouponsGrantedCard({ metrics, timeRange }) {
  const { setApp } = useContext(AppContext);

  const isNewClickable = metrics?.couponsGrantedNew > 0;
  const isReturningClickable = metrics?.couponsGrantedRepeat > 0;
  const isReferrersClickable = metrics?.couponsGrantedAffiliate > 0;

  const onClickHandler = (subType) => getFilteredContacts(setApp, history, {
    type: DashboardFilteresTypes.DiscountsGranted,
    subType,
    ...timeRange,
  });

  const mutateAnalytics = useMutateAnalytics()

  const history = useHistory();
  return (
    <Card title="Discounts Granted">
      <CardHeaderNumber>
        {metrics?.couponsGrantedTotal.toString()}
      </CardHeaderNumber>
      <CardContentLine
        left="New Customers"
        right={metrics?.couponsGrantedNew.toString()}
        color={isNewClickable ? colors.seaGreen : colors.grey2}
        onClick={isNewClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_DISCOUNTS_GRANTED_NEW_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.New);
        }: null}
      />
      <CardContentLine
        left="Returning Customers"
        right={metrics?.couponsGrantedRepeat.toString()}
        color={isReturningClickable ? colors.seaGreen : colors.grey2}
        onClick={isReturningClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_DISCOUNTS_GRANTED_RETURNING_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.Returning);
        } : null}
      />
      <CardContentLine
        left="Referrers"
        right={metrics?.couponsGrantedAffiliate.toString()}
        color={isReferrersClickable ? colors.seaGreen : colors.grey2}
        onClick={isReferrersClickable ? () => {
          const mutateAnalyticsVariables = {
            link: analyticsKeys.DASHBOARD_DISCOUNTS_GRANTED_REFERRERS_CUSTOMER,
          };
          mutateAnalytics(mutateAnalyticsVariables);
          onClickHandler(DashboardFiltersSubTypes.Referrers);
        } : null}
      />
    </Card>
  );
}
